import { makeStyles } from '@material-ui/core/styles';
import { primaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { spacing, colors, fonts, fontSize, sizes } = redesignTheme;

export const useQcmEditorStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.md,
  },
  questionInput: {
    width: '100%',
    minHeight: 48,
    padding: 12,
    boxSizing: 'border-box',
    border: `1px solid #d1d5dc`,
    borderRadius: 4,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    resize: 'vertical',
    outline: 'none',
    '&::placeholder': {
      color: 'rgba(10, 10, 10, 0.5)',
    },
    '&:focus': {
      borderColor: colors.primaryDark,
    },
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
    width: '100%',
  },
  fieldLabel: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
  },
  select: {
    width: '100%',
    height: sizes.inputHeight,
    padding: '0 12px',
    boxSizing: 'border-box',
    border: `1px solid #d1d5dc`,
    borderRadius: 4,
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.text,
    outline: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23000b33' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 12px center',
    '&:focus': {
      borderColor: colors.primaryDark,
    },
  },
  optionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.xs,
  },
  optionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    padding: 12,
    border: `1px solid #d1d5dc`,
    borderRadius: 4,
    backgroundColor: colors.white,
  },
  choiceIndicator: {
    flexShrink: 0,
    width: 14,
    height: 14,
    border: `1px solid ${colors.placeholder}`,
    borderRadius: '50%',
  },
  choiceIndicatorCheckbox: {
    borderRadius: 2,
  },
  optionInput: {
    flex: 1,
    minWidth: 0,
    border: 0,
    outline: 'none',
    resize: 'none',
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: '24px',
    color: colors.primaryDark,
    background: 'transparent',
    '&::placeholder': {
      color: colors.placeholder,
    },
  },
  otherBlock: {
    width: '100%',
  },
  otherLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.xs,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
  },
  otherPreview: {
    width: '100%',
    marginTop: 4,
    padding: 8,
    border: 0,
    borderRadius: 0,
    backgroundColor: colors.hoverSurface,
    fontFamily: fonts.opensans,
    fontSize: fontSize.sm,
    color: colors.placeholder,
    resize: 'none',
    outline: 'none',
  },
  deleteOptionBtn: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
  },
  deleteOptionIcon: {
    width: 16,
    height: 16,
    fill: colors.primaryDark,
  },
  addOtherLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.primaryDark,
    textDecoration: 'underline',
    letterSpacing: '0.28px',
  },
  addOptionButton: {
    ...primaryButtonStyle,
    width: '100%',
    '&:hover': {
      backgroundColor: colors.primary,
    },
  },
}));
